import createImmutableSelector from 'lib/immutable/selector'
import { IAboutLayout } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getAboutLayout = (state: any): IAboutLayout => state.get('aboutLayoutReducer')

export const aboutLayoutSelector = createImmutableSelector(getAboutLayout, (aboutLayout) => aboutLayout)
